module.exports = __webpack_public_path__ + "static/img/merchant_banner.b2c57ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_banner.png
// module id = jBCI
// module chunks = 8